module.exports = __webpack_public_path__ + "img/Master-5.852479b5.png";